import { Cart } from "@olga-food/schemas/lib/classes/schemas/order/cart/Cart";
import { SaiposOrderItem } from "./SaiposOrderItem";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export class SaiposOrder {
  #order = null;
  #storeId = null;
  #orderId = null;
  #tableId = null;

  constructor({ order, storeId, orderId, tableId }) {
    this.#order = order;

    this.#storeId = storeId;

    this.#orderId = orderId;
    
    this.#tableId = tableId;
  }

  get order_id() {
    return String(this.#orderId);
  }

  get display_id() {
    const currentDate = dayjs().tz("America/Sao_Paulo");
    const timestamp = currentDate.unix();
    return `OF-${timestamp}`;
  }


  get cod_store() {
    return String(this.#storeId);
  }

  get created_at() {
    const currentDate = dayjs().tz("America/Sao_Paulo");
    return currentDate.toISOString();
  }

  get notes() {
    return this.#order.observation;
  }

  get total_discount() {
    return 0;
  }

  get total_amount() {
    return +this.#order.total;
  }

  get order_method() {
    return {
      mode: "TABLE",
      table_reference: "",
    };
  }

  get items() {
    const originalCart = JSON.parse(JSON.stringify(this.#order.cart));

    /** Aplica regra de agrupamento de itens de acordo com o tipo do calculo de preço da Question */
    const cartBuilt = Cart.fromObject({
      type: "cart",
      catalog: originalCart.catalog,
      total: originalCart.total,
    });
    const groupedCart = Cart.groupItems(cartBuilt);

    return Object.values(groupedCart?.catalog?.items || [])
      .map((item) => SaiposOrderItem.from(item));
  }

  get table() {
    return {
      desc_table: String(this.#tableId),
    };
  }

  get customer() {
    return null;
  }

  export() {
    return {
      order_id: this.order_id,
      display_id: this.display_id,
      cod_store: this.cod_store,
      created_at: this.created_at,
      notes: this.notes,
      total_discount: this.total_discount,
      total_amount: this.total_amount,
      // customer: null,
      order_method: this.order_method,
      items: this.items,
      table: this.table,
    };
  }
}
